export interface INavigationRoute {
  name: string
  displayName: string
  /**
   * `requiredScope` gates on a backend permission rather than a role string. Hiding the item is
   * cosmetic only — the API enforces the same scope on the route.
   */
  meta: { icon: string; allowedRoles?: string[]; requiredScope?: string; navDisabled?: boolean }
  children?: INavigationRoute[]
}

import { recruitmentTrainingNavigationRoute } from './recruitmentTrainingNavigation'

const sidebarRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard-v2',
      displayName: 'Monthly Dashboard',
      meta: {
        icon: 'dashboard',
        allowedRoles: ['admin', 'manager', 'org_admin'],
      },
    },
    {
      name: 'scorecard',
      displayName: 'Scorecard',
      meta: {
        icon: 'assessment',
        allowedRoles: ['admin', 'operator', 'manager', 'org_admin', 'analyst', 'finance'],
      },
    },
    {
      name: 'ev-dashboard',
      displayName: 'EV Dashboard',
      meta: {
        icon: 'electric_car',
        allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
      },
      children: [
        {
          name: 'charging-stations',
          displayName: 'Charging Stations',
          meta: {
            icon: 'ev_station',
            allowedRoles: [
              'admin',
              'operator',
              'manager',
              'org_admin',
              'support_agent',
              'guest',
              'team_manager',
              'finance',
              'finance-staff',
            ],
          },
        },
        {
          name: 'charging-sessions',
          displayName: 'Charging Sessions',
          meta: {
            icon: 'bolt',
            allowedRoles: [
              'admin',
              'operator',
              'manager',
              'org_admin',
              'support_agent',
              'guest',
              'team_manager',
              'finance',
              'finance-staff',
            ],
          },
        },
        {
          name: 'charging-station-settings',
          displayName: 'Charging Station Settings',
          meta: {
            icon: 'settings',
            allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
          },
        },
      ],
    },
    {
      name: 'our-drivers',
      displayName: 'Drivers',
      meta: {
        icon: 'moped',
        allowedRoles: [
          'admin',
          'operator',
          'manager',
          'org_admin',
          'owner',
          'recruiter',
          'support_agent',
          'guest',
          'team_manager',
          'analyst',
          'finance',
          'finance-staff',
          'developer',
          'driver',
          'client_portal',
          'analyst_viewer_org',
        ],
      },
      children: [
        {
          name: 'our-drivers',
          displayName: 'All Drivers',
          meta: {
            icon: 'moped',
            allowedRoles: [
              'admin',
              'operator',
              'manager',
              'org_admin',
              'owner',
              'recruiter',
              'support_agent',
              'guest',
              'team_manager',
              'analyst',
              'finance',
              'finance-staff',
              'developer',
              'driver',
              'client_portal',
              'analyst_viewer_org',
            ],
          },
        },
        {
          name: 'finance-ledgers',
          displayName: 'Finance Ledger',
          meta: {
            icon: 'receipt_long',
            allowedRoles: ['admin', 'manager', 'org_admin', 'finance', 'finance-staff'],
          },
        },
        {
          name: 'outbound-messages',
          displayName: 'Outbound Messages',
          meta: {
            icon: 'chat',
            allowedRoles: [
              'admin',
              'manager',
              'org_admin',
              'finance',
              'finance-staff',
              'support_agent',
              'team_manager',
            ],
          },
        },
        {
          name: 'invoices',
          displayName: 'Invoices',
          meta: {
            icon: 'request_quote',
            allowedRoles: ['admin', 'manager', 'org_admin', 'finance', 'finance-staff'],
          },
        },
        {
          name: 'driver-matching',
          displayName: 'Driver Matching',
          meta: {
            icon: 'link',
            allowedRoles: ['admin', 'operator', 'manager', 'org_admin', 'owner', 'recruiter', 'support_agent'],
          },
        },
      ],
    },
    recruitmentTrainingNavigationRoute,
    {
      name: 'our-vehicles',
      displayName: 'Assets',
      meta: {
        icon: 'directions_car',
        allowedRoles: [
          'admin',
          'operator',
          'manager',
          'org_admin',
          'owner',
          'recruiter',
          'support_agent',
          'guest',
          'team_manager',
          'analyst',
          'finance',
          'finance-staff',
          'developer',
          'driver',
          'client_portal',
          'analyst_viewer_org',
        ],
      },
      children: [
        {
          name: 'our-vehicles',
          displayName: 'Mobile Assets',
          meta: {
            icon: 'directions_car',
            allowedRoles: [
              'admin',
              'operator',
              'manager',
              'org_admin',
              'owner',
              'recruiter',
              'support_agent',
              'guest',
              'team_manager',
              'analyst',
              'finance',
              'finance-staff',
              'developer',
              'driver',
              'client_portal',
              'analyst_viewer_org',
            ],
          },
        },
        {
          name: 'tracking-devices',
          displayName: 'Tracking Devices',
          meta: {
            icon: 'gps_fixed',
            allowedRoles: ['admin', 'operator', 'manager', 'org_admin', 'owner', 'support_agent', 'developer'],
          },
        },
        {
          name: 'vehicle-mapping',
          displayName: 'Vehicle Mapping',
          meta: {
            icon: 'link',
            allowedRoles: ['admin', 'operator', 'manager', 'org_admin', 'owner', 'support_agent'],
          },
        },
      ],
    },
    // {
    //   name: 'users',
    //   displayName: 'Users',
    //   meta: {
    //     icon: 'group',
    //     allowedRoles: ['admin', 'manager', 'org_admin'],
    //   },
    // },
    // {
    //   name: 'driver-activity',
    //   displayName: 'Driver Activity',
    //   meta: {
    //     icon: 'analytics',
    //     allowedRoles: [
    //       'admin',
    //       'operator',
    //       'manager',
    //       'org_admin',
    //       'owner',
    //       'analyst',
    //       'finance',
    //       'developer',
    //       'driver',
    //       'recruiter',
    //     ],
    //   },
    //   children: [
    //     {
    //       name: 'driver-activity',
    //       displayName: 'Driver Activity (Leaflet)',
    //       meta: {
    //         icon: 'map',
    //         allowedRoles: [
    //           'admin',
    //           'operator',
    //           'manager',
    //           'org_admin',
    //           'owner',
    //           'analyst',
    //           'finance',
    //           'developer',
    //           'driver',
    //           'recruiter',
    //         ],
    //       },
    //     },
    //     {
    //       name: 'driver-activity-google',
    //       displayName: 'Driver Activity (Google Maps)',
    //       meta: {
    //         icon: 'public',
    //         allowedRoles: [
    //           'admin',
    //           'operator',
    //           'manager',
    //           'org_admin',
    //           'owner',
    //           'analyst',
    //           'finance',
    //           'developer',
    //           'driver',
    //           'recruiter',
    //         ],
    //       },
    //     },
    //   ],
    // },
    // {
    //   name: 'messages',
    //   displayName: 'Messages',
    //   meta: {
    //     icon: 'message',
    //     allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
    //   },
    // },
    {
      name: 'reports',
      displayName: 'Reports',
      meta: {
        icon: 'today',
        allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
      },
      children: [
        {
          name: 'reports',
          displayName: 'All Reports',
          meta: {
            icon: 'assessment',
            allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
          },
        },
        {
          name: 'odometer-reports',
          displayName: 'Odometer Reports',
          meta: {
            icon: 'speed',
            allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
          },
        },
        {
          name: 'charging-reports',
          displayName: 'Charging Reports',
          meta: {
            icon: 'battery_charging_full',
            allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
          },
        },
        {
          name: 'vehicle-activity-reports',
          displayName: 'Vehicle Activity',
          meta: {
            icon: 'sensors',
            allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
          },
        },
        {
          name: 'fleet-telemetry-reports',
          displayName: 'Fleet Telemetry',
          meta: {
            icon: 'sensors',
            allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
          },
        },
        {
          name: 'battery-swap-reports',
          displayName: 'Battery Swaps',
          meta: {
            icon: 'battery_charging_full',
            allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
          },
        },
        {
          name: 'trips',
          displayName: 'Trips',
          meta: {
            icon: 'folder_shared',
            allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
          },
        },
        {
          name: 'uteh-vehicles',
          displayName: 'UTEH Vehicles',
          meta: {
            icon: 'directions_car',
            allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
          },
        },
      ],
    },
    // {
    //   name: 'issues',
    //   displayName: 'Tickets',
    //   meta: {
    //     icon: 'dataset',
    //     allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
    //   },
    // },
    // {
    //   name: 'analytics',
    //   displayName: 'Analytics',
    //   meta: {
    //     icon: 'analytics',
    //     allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
    //   },
    // },
    {
      name: 'operators',
      displayName: 'Operators',
      meta: {
        icon: 'support_agent',
        allowedRoles: ['admin', 'manager', 'org_admin'],
      },
      children: [
        {
          name: 'driver-support-manage',
          displayName: 'Support Chat Management',
          meta: {
            icon: 'forum',
            allowedRoles: ['team_manager', 'admin', 'org_admin', 'owner', 'manager'],
          },
        },
        {
          name: 'operators',
          displayName: 'Operator Users',
          meta: {
            icon: 'support_agent',
            allowedRoles: ['admin', 'manager', 'org_admin'],
          },
        },
      ],
    },
    {
      name: 'tickets',
      displayName: 'Tickets',
      meta: {
        icon: 'assignment',
        allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
      },
    },
    {
      name: 'maintenance',
      displayName: 'Maintenance',
      meta: {
        icon: 'engineering',
        allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
      },
      children: [
        {
          name: 'maintenance',
          displayName: 'Maintenance List',
          meta: {
            icon: 'list',
            allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
          },
        },
        {
          name: 'maintenance-items',
          displayName: 'Maintenance Items',
          meta: {
            icon: 'inventory',
            allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
          },
        },
        {
          name: 'maintenance-workshops',
          displayName: 'Workshops',
          meta: {
            icon: 'business',
            allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
          },
        },
      ],
    },
    {
      name: 'admin-management',
      displayName: 'Admin Management',
      meta: {
        icon: 'admin_panel_settings',
        allowedRoles: ['admin', 'manager', 'org_admin'],
      },
      children: [
        {
          name: 'immobiliser',
          displayName: 'Immobiliser',
          meta: {
            icon: 'car_crash',
            allowedRoles: ['admin', 'manager', 'org_admin'],
            requiredScope: 'vehicles.immobilise',
          },
        },
        // {
        //   name: 'role-management',
        //   displayName: 'Role Management',
        //   meta: {
        //     icon: 'security',
        //     allowedRoles: ['admin', 'org_admin'],
        //   },
        // },
        {
          name: 'user-management',
          displayName: 'User Management',
          meta: {
            icon: 'group',
            allowedRoles: ['admin', 'manager', 'org_admin'],
          },
        },
        {
          name: 'user-monitoring',
          displayName: 'User Monitoring',
          meta: {
            icon: 'analytics',
            allowedRoles: ['admin', 'manager', 'org_admin'],
          },
        },
        {
          name: 'contractor-management',
          displayName: 'Contractor Management',
          meta: {
            icon: 'business',
            allowedRoles: ['admin', 'manager', 'org_admin'],
          },
        },
        {
          name: 'bulk-upload-assets',
          displayName: 'Bulk Upload Assets',
          meta: {
            icon: 'upload_file',
            allowedRoles: ['admin', 'manager', 'org_admin'],
          },
        },
      ],
    },
    {
      name: 'finance',
      displayName: 'Finance',
      meta: {
        icon: 'account_balance',
        allowedRoles: ['admin', 'manager', 'org_admin', 'finance', 'finance-staff'],
      },
      children: [
        {
          name: 'financial-upload',
          displayName: 'Upload Financial Sheet',
          meta: {
            icon: 'upload_file',
            allowedRoles: ['admin', 'manager', 'org_admin', 'finance', 'finance-staff'],
          },
        },
      ],
    },
    {
      name: 'profile',
      displayName: 'Profile',
      meta: {
        icon: 'manage_accounts',
        allowedRoles: [
          'admin',
          'operator',
          'manager',
          'org_admin',
          'owner',
          'analyst',
          'finance',
          'developer',
          'driver',
          'recruiter',
          'support_agent',
          'team_manager',
          'guest',
        ],
      },
    },
    // {
    //   name: 'demo',
    //   displayName: 'Demo',
    //   meta: {
    //     icon: 'science',
    //     allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
    //   },
    //   children: [
    //     {
    //       name: 'demo-uber-region',
    //       displayName: 'Uber Region Demo',
    //       meta: {
    //         icon: 'public',
    //         allowedRoles: ['admin', 'operator', 'manager', 'org_admin'],
    //       },
    //     },
    //   ],
    // },
  ],
}

export default sidebarRoutes
